export const parseQueryValue = <T extends string>(queryValue: unknown): T | null => {
  if (!queryValue) {
    return null
  }

  const parsedValue = (Array.isArray(queryValue) ? queryValue[0] : queryValue) as T

  return parsedValue ?? null
}
